<template>
  <section class="add-students pa-3">
    <h2>Add New Students to your Class</h2>
    <p>
      For privacy reasons, all student data is totally anonymous. We recommend
      keeping a list of which student codes apply to which of your students in
      order to monitor progression throughout the program.
    </p>
    <v-row justify="center" class="mb-2">
      <v-col
        cols="12"
        v-for="(student, index) in studentList"
        :key="'enrolee-' + index"
      >
        <v-row justify="center">
          <v-col md="1" cols="2">
            <span class="student-index">{{ index + 1 }}</span>
          </v-col>
        </v-row>
        <v-divider v-show="$vuetify.breakpoint.xs" class="pb-4" />
      </v-col>
      <v-col cols="12">
        <v-row justify="end">
          <v-btn
            @click="inviteStudents"
            :loading="loading"
            :disabled="loading"
            color="primary"
          >
            add students
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { focus } from 'vue-focus'
import { mapMutations, mapGetters } from 'vuex'
import _ from 'lodash'
import ClassInvitation from '@/modules/class/models/ClassInvitation'

export default {
  name: 'AddStudents',
  directives: { focus: focus },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      loading: false,
      studentList: [
        {
          email: '',
          username: '',
          focused: false,
          error: [],
          errorEmail: []
        }
      ]
    }
  },
  watch: {
    studentList: {
      handler: function(val) {
        if (val[val.length - 1].username !== '') {
          // add a new object at the end of array
          this.studentList.push({
            focused: false,
            error: [],
            errorEmail: []
          })
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('entities/classes', ['currentClassId'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async inviteStudents() {
      let studentListArray = []
      let validate = true
      this.studentList.forEach((s, index) => {
        if (
          (s.error.length || s.errorEmail.length) &&
          index !== this.studentList.length - 1
        ) {
          validate = false
          return
        }
        let student = {
          // username: s.username
          username: 'dummy'
        }
        // if (s.email !== '') {
        //   student.email = s.email
        // }

        studentListArray.push(student)
      })

      if (!validate) {
        return
      }
      this.loading = true

      // remove empty objects
      _.remove(studentListArray, currentObject => !currentObject.username)

      const payload = {
        students: studentListArray,
        class_id: this.currentClassId
      }

      try {
        await ClassInvitation.dispatch('createInvitations', { payload })
        this.studentList = [
          {
            username: '',
            focused: false,
            error: [],
            errorEmail: []
          }
        ]
        await ClassInvitation.dispatch('getClassInvitations', {
          classId: this.currentClassId
        })
        this.showSnackbar('Invitations successfully created.')
        setTimeout(() => {
          this.loading = false
          this.$emit('changeTab', 2)
        }, 500)
      } catch (error) {
        this.showErrorSnackbar('Error creating the invitations')
        this.loading = false
      }
    },
    addStudent() {
      let student = { username: this.currentInput }
      this.studentList.push(student)
      this.currentInput = ''
    },
    removeStudent(event, index) {
      let username = event.target.value
      if (username.length === 0) {
        this.studentList.splice(index, 1)
      }
    },
    focusOnNextField(student, index) {
      student.focused = false
      this.$set(this.studentList, index, student)
      let nextStudent = this.studentList[index + 1]
      nextStudent.focused = true
      this.$set(this.studentList, index + 1, nextStudent)
    },
    onFocus(student, index, type) {
      if (type === 'studentname' && student.error.length) {
        student.error = []
      } else if (type === 'email' && student.error.length) {
        student.errorEmail = []
      }

      student.focused = true
      this.$set(this.studentList, index, student)
    },
    onLostFocus(student, index) {
      if (student.username === '' && index !== this.studentList.length - 1) {
        if (student.email !== '') {
          student.error.push('Student name is required')
        } else {
          this.$delete(this.studentList, index)
          return
        }
      }
      if (student.email !== '' && !this.isValidEmail(student.email)) {
        student.errorEmail.push('Valid email is required')
      } else {
        student.errorEmail = []
      }
      student.focused = false
      this.$set(this.studentList, index, student)
    },
    isValidEmail(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    }
  }
}
</script>

<style lang="scss">
.add-students {
  h2 {
    color: var(--v-primary-base);
  }
  span.student-index {
    color: white;
    background: var(--v-primary-base);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    display: block;
    text-align: center;
    margin-top: 10px;
  }

  .center-elem {
    text-align: center;
    > * {
      display: inline-block;
      vertical-align: center;
    }
  }
}
</style>
